import PageMeta from "~/components/common/meta";
import { Assignments } from "~/components/staff/assignments";

export const AssignmentsScreen = () => {
  return (
    <>
      <PageMeta title="My Assignments | Art Handler" />
      <Assignments />
    </>
  );
};
